// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__X6b8o","large":"Button_large__nYkaG","small":"Button_small__Hr_1s"};